import React from 'react';
import { Header, HeaderProps } from 'semantic-ui-react';

type Props = {
  content?: string;
  extra?: React.ReactNode;
} & HeaderProps;

const PageTitle: React.FC<Props> = ({
  children,
  content,
  className = '',
  extra,
  ...rest
}) => {
  return (
    <Header
      className={`typography_page_title d-flex-between ${className}`}
      content={content}
      {...rest}
    >
      {children} {extra}
    </Header>
  );
};

export default PageTitle;
